export default {

// 57             مرخصی روزانه
// 17           مرخصی ساعتی
// 303                 اضافه کار
// 51                    ماموریت
// 9          ماموریت ساعتی
// 305     تردد فراموش شده

  leaveRequests: (state) => {
    return state.allRequests.filter((e) => e.card_No === 17 || e.card_No === 57);
  },
  managerLeaveRequests: (state) => {
    return state.managerAllRequests.filter((e) => e.card_No === 17 || e.card_No === 57);
  },

  missions: (state) => {
    return state.allRequests.filter((e) => e.card_No === 9 || e.card_No === 51);
  },
  managerMissions: (state) => {
    return state.managerAllRequests.filter((e) => e.card_No === 9 || e.card_No === 51);
  },

  extraWorks: (state) => {
    return state.allRequests.filter((e) => e.card_No === 303);
  },
  managerExtraWorks: (state) => {
    return state.managerAllRequests.filter((e) => e.card_No === 303);
  },

  forgottenTraffics: (state) => {
    return state.allRequests.filter((e) => e.card_No === 305);
  },
  managerForgottenTraffics: (state) => {
    return state.managerAllRequests.filter((e) => e.card_No === 305);
  },

  remainLeaves: (state) => {
    return state.remainLeaves;
  },

  dailyWorks: (state) => {
    state.dailyWorks.forEach((item) => {
      item.cards = [];
      for (let i = 1; i < 25; i++) {
        if(item["card" + i]) {
          item.cards.push(item["card" + i]);
        }
      }
    });
    return state.dailyWorks;
  },

  insuranceList: (state) => {
    return state.insuranceList;
  },
  insuranceFee: (state) => {
    return state.insuranceFee;
  },
  insuranceFeeTitle: (state) => {
    return state.insuranceFeeTitle;
  },

  suggestionList: (state) => {
    return state.suggestionList;
  },
  managerSuggestionList: (state) => {
    return state.managerSuggestionList;
  },

  departmentOptions: (state) => {
    const options = [];
    state.departments.forEach((item) => {
      const payload = {
        value: item.depId,
        text: item.depName,
      };
      options.push(payload);
    });
    return options;
  },

  leaveTypeOptions() {
    return [
      {value: 1, text: "ساعتی"},
      {value: 2, text: "روزانه"}
    ];
  },

  vehicleOptions() {
    return [
      {value: 1, text: "خودرو شخصی"},
      {value: 2, text: "قطار"},
      {value: 3, text: "اتوبوس"},
      {value: 4, text: "هواپیما"},
      {value: 5, text: "خودرو شرکتی"},
      {value: 6, text: "تاکسی"},
      {value: 7, text: "دوچرخه"},
      {value: 8, text: "موتور سیکلت"},
    ];
  },

  expertPollHeaders: (state) => {
    return state.expertPollHeaders;
  },
  managerPollHeaders: (state) => {
    return state.managerPollHeaders;
  },
  managerPollsHistory: (state) => {
    return state.managerPollsHistory;
  },
  userPollHeaders: (state) => {
     return state.userPollHeaders;
  },
  pollDetails: (state) => {
    return state.pollDetails;
  },
  answerPollHeaders: (state) => {
    return state.answerPollHeaders;
  },
  answerPollDetails: (state) => {
    return state.answerPollDetails;
  },
  userAnswerPollHeaders: (state) => {
    return state.userAnswerPollHeaders;
  },
  userAnswerPollDetails: (state) => {
    return state.userAnswerPollDetails;
  },

  userComponentAnswers: (state) => {
    return state.userComponentAnswers;
  },

  pollStateOptions() {
    return [
      {value: 2, text: "تأیید"},
      {value: 4, text: "رد و ابطال"},
    ];
  },

  pageTotal: (state) => {
    return state.pageTotal;
  },


};
